var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-input-search',{staticStyle:{"width":"300px"},attrs:{"placeholder":"请输入标题搜索..."},on:{"search":_vm.onSearch},model:{value:(_vm.keyWord),callback:function ($$v) {_vm.keyWord=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"keyWord"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }